var selectedDefect = {};
var animationDuration = 2000;
var frameDuration = 1000 / 60;
var totalFrames = Math.round(animationDuration / frameDuration);

export var breakpoints = {
	mobile: 1024
};

export var doneTypingInterval = 800;

export function fakeUUID() {
	// https://stackoverflow.com/a/2117523
	return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
		var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
		return v.toString(16);
	});
}

export function getImageWrapMarkup(imageData, url) {
	return `<${url ? `a href="${url}"` : 'div'} id="image-${imageData.media.id}" class="image-wrap" data-image-id="${imageData.media.id}"><img loading="lazy" src="${imageData.media.url}" width="${imageData.media.dimensions.width}" height="${imageData.media.dimensions.height}"></${url ? `a` : 'div'}>`;
}

// https://stackoverflow.com/a/1909508
export function delay(callback, ms) {
	var timer = 0;
	return function() {
		var context = this, args = arguments;
		clearTimeout(timer);
		timer = setTimeout(function() {
			callback.apply(context, args);
		}, ms || 0);
	};
}

export function getSelectedDefect() {
	return selectedDefect;
}

export function setSelectedDefect(value) {
	selectedDefect = value;
}

export function swapEls(thisEl, thatEl) {
	var tmp = $('<div>');
	thisEl.before(tmp);
	thatEl.before(thisEl);
	tmp.before(thatEl).remove();
}

export var CSV = {
	parse: function(csv, reviver) {
		reviver = reviver || function(r, c, v) { return v; };
		var chars = csv.split(''), c = 0, cc = chars.length, start, end, table = [], row;
		while (c < cc) {
			table.push(row = []);
			while (c < cc && '\r' !== chars[c] && '\n' !== chars[c]) {
				start = end = c;
				if ('"' === chars[c]){
					start = end = ++c;
					while (c < cc) {
						if ('"' === chars[c]) {
							if ('"' !== chars[c+1]) {
								break;
							}
							else {
								chars[++c] = ''; // unescape ""
							}
						}
						end = ++c;
					}
					if ('"' === chars[c]) {
						++c;
					}
					while (c < cc && '\r' !== chars[c] && '\n' !== chars[c] && ',' !== chars[c]) {
						++c;
					}
				} else {
					while (c < cc && '\r' !== chars[c] && '\n' !== chars[c] && ',' !== chars[c]) {
						end = ++c;
					}
				}
				row.push(reviver(table.length-1, row.length, chars.slice(start, end).join('')));
				if (',' === chars[c]) {
					++c;
				}
			}
			if ('\r' === chars[c]) {
				++c;
			}
			if ('\n' === chars[c]) {
				++c;
			}
		}
		return table;
	},
	stringify: function(table, replacer) {
		replacer = replacer || function(r, c, v) { return v; };
		var csv = '', c, cc, r, rr = table.length, cell;
		for (r = 0; r < rr; ++r) {
			if (r) {
				csv += '\r\n';
			}
			for (c = 0, cc = table[r].length; c < cc; ++c) {
				if (c) {
					csv += ',';
				}
				cell = replacer(r, c, table[r][c]);
				if (/[,\r\n"]/.test(cell)) {
					cell = '"' + cell.replace(/"/g, '""') + '"';
				}
				csv += (cell || 0 === cell) ? cell : '';
			}
		}
		return csv;
	}
};

export function easeOutQuad(t) {
	return t * (2 - t);
};

export function animationCount(el, from, to) {
	var frame = 0;
	var countFrom = parseInt(from);
	var countTo = parseInt(to);
	var diff = countTo - countFrom;
	var direction = 'up';
	if (diff < 0) {
		direction = 'down';
		diff = countFrom - countTo;
	}
	var counter = setInterval(function() {
		frame++;
		var progress = easeOutQuad(frame / totalFrames);
		var currentCount = countFrom + Math.round(diff * progress);
		if (direction == 'down') {
			currentCount = countFrom - Math.round(diff * progress);
		}
		if (parseInt(el.attr('data-number')) !== currentCount) {
			el.attr('data-number', currentCount);
			var num = Intl.NumberFormat('en-US', {
				notation: 'compact',
				maximumFractionDigits: (currentCount > 1000 && currentCount < 2000) || currentCount > 1000000 ? 1 : 0
			}).format(currentCount);
			el.html(num);
		} else {
			el.addClass('finished-counting');
		}
		if (frame === totalFrames) {
			clearInterval(counter);
		}
	}, frameDuration);
}
